import React, { useRef, useState } from 'react';
import ReCAPTCHA from 'react-google-recaptcha';
import './ContactFormNew.css';

function ContactFormNew() {
  const formRef = useRef(null);
  const recaptchaRef = useRef(null);

  const [formData, setFormData] = useState({
    firstName: '',
    lastName: '',
    email: '',
    phoneNumber: '',
    company: '',
    serviceOfInterest: '',
    message: '',
  });

  const [recaptchaToken, setRecaptchaToken] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [startTime] = useState(Date.now());

  const handleChange = (e) => {
    const { name, value } = e.target;

    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const resetForm = () => {
    setFormData({
      firstName: '',
      lastName: '',
      email: '',
      phoneNumber: '',
      company: '',
      serviceOfInterest: '',
      message: '',
    });
    setRecaptchaToken('');

    if (recaptchaRef.current) {
      recaptchaRef.current.reset();
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const timeTaken = Date.now() - startTime;

    if (timeTaken < 3000) {
    alert('Submission too fast.');
    return;
  }

  if (!recaptchaToken) {
    alert('Please complete reCAPTCHA.');
    return;
  }


    if (!recaptchaToken) {
      alert('Please complete the reCAPTCHA challenge.');
      return;
    }

    setIsSubmitting(true);

    try {
      const submission = new FormData();

      submission.append('firstName', formData.firstName);
      submission.append('lastName', formData.lastName);
      submission.append('email', formData.email);
      submission.append('phoneNumber', formData.phoneNumber);
      submission.append('company', formData.company);
      submission.append('serviceOfInterest', formData.serviceOfInterest);
      submission.append('message', formData.message);

      submission.append('_subject', 'New Yokai Software Contact Form Submission');
      submission.append('_template', 'table');
      submission.append('_captcha', 'false');
      submission.append('_replyto', formData.email);
      submission.append('_next', window.location.href);

      const response = await fetch('https://formsubmit.co/ajax/contact@yokaisoftware.com', {
        method: 'POST',
        headers: {
          Accept: 'application/json',
        },
        body: submission,
      });

      const result = await response.json();

      if (result.success === 'true' || response.ok) {
        alert('Your message was sent successfully.');
        resetForm();
      } else {
        alert('There was a problem sending your message. Please try again.');
      }
    } catch (error) {
      console.error('Form submission error:', error);
      alert('There was a problem sending your message. Please try again.');
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleRecaptchaChange = (token) => {
    setRecaptchaToken(token || '');
  };

  return (
    <div className="contact-form-new-wrap">
      <div className="contact-form-new-title">
        <h1>Get In Touch With Us</h1>
        <p>Tell us about your project, goals, or questions.</p>
      </div>

      <form ref={formRef} className="contact-form-new" onSubmit={handleSubmit}>
        <div className="contact-form-new-grid two-col">
          <div className="contact-form-new-field">
            <label htmlFor="firstName">First Name</label>
            <input
              type="text"
              id="firstName"
              name="firstName"
              value={formData.firstName}
              onChange={handleChange}
              required
            />
          </div>

          <div className="contact-form-new-field">
            <label htmlFor="lastName">Last Name</label>
            <input
              type="text"
              id="lastName"
              name="lastName"
              value={formData.lastName}
              onChange={handleChange}
              required
            />
          </div>
        </div>

        <div className="contact-form-new-grid two-col">
          <div className="contact-form-new-field">
            <label htmlFor="email">Email</label>
            <input
              type="email"
              id="email"
              name="email"
              value={formData.email}
              onChange={handleChange}
              required
            />
          </div>

          <div className="contact-form-new-field">
            <label htmlFor="phoneNumber">Phone Number</label>
            <input
              type="text"
              id="phoneNumber"
              name="phoneNumber"
              value={formData.phoneNumber}
              onChange={handleChange}
              required
            />
          </div>
        </div>

        <div className="contact-form-new-grid two-col">
          <div className="contact-form-new-field">
            <label htmlFor="company">Company</label>
            <input
              type="text"
              id="company"
              name="company"
              value={formData.company}
              onChange={handleChange}
              required
            />
          </div>

          <div className="contact-form-new-field">
            <label htmlFor="serviceOfInterest">Service of Interest</label>
            <input
              type="text"
              id="serviceOfInterest"
              name="serviceOfInterest"
              value={formData.serviceOfInterest}
              onChange={handleChange}
              required
            />
          </div>
        </div>

        <div className="contact-form-new-field">
          <label htmlFor="message">Message</label>
          <textarea
            id="message"
            name="message"
            value={formData.message}
            onChange={handleChange}
            required
          />
        </div>

        <input type="text" name="_honey" style={{ display: 'none' }} />
        <input type="hidden" name="_timestamp" value={Date.now()} />
        <input type="hidden" name="_captcha" value="false" />

        <div className="contact-form-new-bottom">
          <div className="contact-form-new-captcha">
            <ReCAPTCHA
              ref={recaptchaRef}
              sitekey="6LdwstIpAAAAAL1_lBneLQEQRHpyUpxdO5ZXJ0R9"
              onChange={handleRecaptchaChange}
            />
          </div>

          <button
            className="contact-form-new-button"
            type="submit"
            disabled={isSubmitting}
          >
            {isSubmitting ? 'Sending...' : 'Submit'}
          </button>
        </div>
      </form>
    </div>
  );
}

export default ContactFormNew;